export default __webpack_public_path__ + "static/V0_Oikea_valotus2-d5c50408902cfa22a71debd50e880372.jpg";